/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRect2TextIcon16Solid = forwardRef('CommentRect2TextIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3.5A2.5 2.5 0 0 1 2.5 1h8A2.5 2.5 0 0 1 13 3.5v5a2.5 2.5 0 0 1-2.5 2.5H8.577l-5.012 3.43A1 1 0 0 1 2 13.603V10.95A2.5 2.5 0 0 1 0 8.5v-5ZM3.5 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM3 5.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "m8.955 12-1.4 1H8.75l3.695 2.463A1 1 0 0 0 14 14.633V12.95a2.5 2.5 0 0 0 2-2.45v-5a2.5 2.5 0 0 0-2-2.45V9a3 3 0 0 1-3 3H8.955Z" })));
});
